/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */

import React, {useEffect} from "react";
import {STATISTIC_EVENTS} from "@/app/constants";
import LayoutFullWidth from "@/app/components/layouts/LayoutFullWidth";
import classes from "@/app/components/homepage/homepageStyles.module.scss";
import processCmsPage from "@/app/connector/pageBuilder/processCmsPage";
import {TCmsPageData} from "@/app/types/prefetchedData/cmsPageData";
import {TSliderWidgetsData} from "@/app/types/sliderWidgetsData";
import {triggerEvent} from "@/app/utils/statistic";

const HomepageContent = (props:{
    cmsPageData: TCmsPageData
    sliderWidgetsData: TSliderWidgetsData
}) => {
    const {cmsPageContent, cmsPage} = processCmsPage(props.cmsPageData);

    const metaTitle = cmsPage?.meta_title ?? cmsPage?.title ?? 'Homepage';
    const metaDescription = cmsPage?.meta_description ?? 'Homepage';

    useEffect(() => {
        if (props.sliderWidgetsData.errorMessage) {
            console.log(props.sliderWidgetsData.errorMessage);
        }

        // Trigger event to be able to send statistic data
        triggerEvent({
            type: STATISTIC_EVENTS.pageView,
            details: {
                pageData: cmsPage,
            }
        });
    },[])

    return <LayoutFullWidth
        headTitle={metaTitle}
        metaDescription={metaDescription ?? metaTitle}
        mainContainerClassName={classes.homepage}
        canonical={"/"}
    >

        <div className={classes.homepageContent}>
            {cmsPageContent}
        </div>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: `{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "D&B Supply",
          "url": "${process.env.NEXT_PUBLIC_APP_URL}",
          "logo": "${process.env.NEXT_PUBLIC_APP_URL?.endsWith('/')
                    ? process.env.NEXT_PUBLIC_APP_URL.slice(0, -1)
                    : process.env.NEXT_PUBLIC_APP_URL}/assets/header/HeaderLogo.svg"
        }`}}
        />
    </LayoutFullWidth>;
}

export default React.memo(HomepageContent);